import { BaseTopMenuApi } from './api.base';

export class DemoTopMenuApi extends BaseTopMenuApi {

    async getSite(id: any): Promise<any> {
        return {}
    }

}
